<template>
    <v-row class="align-baseline">
        <v-col cols="4">
            <v-select :items="seasons"
                      v-model="quarter.quarter"
                      label="Season"
                      item-value="value"
                      item-text="label"
                      outlined
                      dense
                      hide-details
                      placeholder="Season"/>
        </v-col>
        <v-col cols="3">
            <v-menu
                v-model="showStartDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formatDate(quarter.start_date)"
                        append-icon="mdi-calendar"
                        class="min-width-115"
                        readonly
                        label="Start date"
                        outlined
                        dense
                        hide-details
                        placeholder="Start date"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                    first-day-of-week="1"
                    v-model="quarter.start_date"
                    @input="showStartDateMenu = false"
                ></v-date-picker>
            </v-menu>
        </v-col>
        <v-col cols="4">
            <v-select item-value="id"
                      item-text="code"
                      hide-details
                      outlined
                      dense
                      multiple
                      :items="countries"
                      placeholder="Countries"
                      label="Countries"
                      v-model="quarter.countries"/>
        </v-col>
        <v-col cols="1" class="text-right">
            <v-btn @click="handleSaveClick" x-small color="primary" class="mr-1">
                <v-icon small>mdi-content-save-outline</v-icon>
            </v-btn>
            <v-btn @click="handleDeleteClick" x-small color="error">
                <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';

export default {
    name: 'AnnualSummaryConfigurationSeasonStartDateComponent',
    props: ['quarter'],
    data() {
        return {
            showStartDateMenu: false,
            seasons: [
                {
                    label: 'Winter',
                    value: 'Winter',
                },
                {
                    label: 'Spring',
                    value: 'Spring',
                },
                {
                    label: 'Summer',
                    value: 'Summer',
                },
                {
                    label: 'Autumn',
                    value: 'Autumn',
                },
            ],
        };
    },

    computed: {
        ...mapState('country', ['countries']),
    },
    methods: {
        ...mapActions('quarter', ['deleteQuarter', 'saveQuarter', 'fetchQuarters']),
        formatDate(date) {
            if (date) {
                return moment(date).format('DD.MM.YYYY');
            }
            return '-';
        },
        async handleDeleteClick() {
            const response = await this.deleteQuarter({quarterId: this.quarter.id})

            if (response) {
                await this.fetchQuarters()
            }
        },
        async handleSaveClick() {
            const response = await this.saveQuarter({quarterId: this.quarter.id, data: this.quarter})

            if (response) {
                await this.fetchQuarters()
            }
        }
    },
};
</script>

<style scoped lang="scss">
</style>